import React from "react";
import InputField from "components/InputField/InputField";
import SelectField from "components/InputField/SelectField";
import FileField from "components/InputField/FileField";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormControl, FormControlLabel } from "material-ui/Form";
import PropTypes from "prop-types";

const labels = {
  first_name: "First name",
  last_name: "Last name",
  email: "Email",
  email_confirmation: "Confirm email",
  password: "Password",
  company_name: "Company",
  sponsor_type: "Sponsor Type",
};

const sponsorTypes = [
  {
    value: 0,
    label: "Pharmaceutical",
  },
  {
    value: 1,
    label: "Private Hospital",
  },
];

const sponsorTypeLabel = {
  pharmaceutical: 0,
  private_hospital: 1,
};

const NewUserSponsorForm = ({
  // user,
  user: {
    first_name,
    last_name,
    email,
    password,
    email_confirmation,
    user_type,
    company_name,
    sponsor_type,
    // is_representative,
  },
  onFieldChange,
  onSubmit,
  errors = {},
  termsOfService,
  onRepresentativeChange,
}) => {
  const sponsorType =
    sponsorTypeLabel[sponsor_type] || sponsorTypeLabel[sponsor_type] === 0
      ? sponsorTypeLabel[sponsor_type]
      : sponsor_type;
  return (
    <div className="container_records">
      <div className="add_webinar add_user">
        <h3>Add Client</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">
            <div className="row">
              {/* {is_representative && (
                <FileField
                  className='col s12'
                  field_name="avatar"
                  onChange={onFieldChange}
                  label={labels['avatar']}
                  errors={errors['avatar']}
                />
              )} */}
              {[
                {
                  field_name: "first_name",
                  value: first_name,
                },
                {
                  field_name: "last_name",
                  value: last_name,
                },
              ].map((e) => (
                <InputField
                  className="col s12 m6"
                  label={labels[e.field_name]}
                  onChange={onFieldChange}
                  errors={errors[e.field_name]}
                  autoComplete="new-password"
                  {...e}
                />
              ))}

              {[
                {
                  field_name: "email",
                  value: email,
                  type: "email",
                  className: "col s12",
                },
                {
                  field_name: "email_confirmation",
                  value: email_confirmation,
                  type: "email",
                  className: "col s12",
                },
                {
                  field_name: "company_name",
                  value: company_name,
                  type: "text",
                  className: "col s12",
                },
                {
                  field_name: "password",
                  value: password,
                  type: "password",
                  className: "col s12",
                },
              ].map((e) => (
                <InputField
                  className="col s12 m6"
                  label={labels[e.field_name]}
                  onChange={onFieldChange}
                  errors={errors[e.field_name]}
                  autoComplete="new-password"
                  {...e}
                />
              ))}
              <SelectField
                className="col s12"
                label={labels["sponsor_type"]}
                onChange={onFieldChange}
                errors={errors["sponsor_type"]}
                autoComplete="new-password"
                field_name="sponsor_type"
                value={sponsorType}
                options={sponsorTypes}
              />
              {/* <div className="col s12 ipna_select">
                <FormControl>
                  <p>Representative</p>
                  <RadioGroup
                    onChange={onRepresentativeChange}
                    value={is_representative}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio color="primary" />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio color="primary" />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </div> */}
              <div className="submit_center col s12">
                <button
                  onClick={onSubmit}
                  className="button_classic"
                  type="button"
                  name="button"
                >
                  Create
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
NewUserSponsorForm.defaultProps = {};

NewUserSponsorForm.propTypes = {
  user: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
  errors: PropTypes.array,
};

export default NewUserSponsorForm;



// WEBPACK FOOTER //
// ./src/components/Admin/UserSponsor/NewUserSponsorForm.jsx